import { View } from 'backbone';
import constants        from "Constants.js";
import BaseControlView from 'BaseControlView.js';
import eventBus         from 'EventBus.js';
import template from 'common-inputs/control_list.ejs';
import listService from 'ListService';
import util from 'util/Util.js';
//=====================================================================
//
// An instance of this view represents a list control.
//
// Brad Trebilcock, January, 17 2016
//
//=====================================================================
class ListControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;

        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, 'addItemOnList', this.render);
        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }

}

export default ListControlView;
